import React from 'react';
import ReactDOM from 'react-dom/client';
import reportWebVitals from './reportWebVitals';
import Chatbot from './pages/Chatgpt';
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
      <Chatbot/>
  </React.StrictMode>
);
reportWebVitals();
